import "whatwg-fetch";
import React from "react";
import Header from "../../header";
import Select from "react-select";
import "react-select/dist/react-select.css";
import { SkyLightStateless } from "react-skylight";
import { styles } from "../../menu/styles";
import RedirectIfNotLogged from "../../menu/redirect-if-not-logged";
import ArticleAddTable from "./articles/ArticleAddTable";
import { Constants } from "../../../constants";
import request from "../../../config/axios-config";
import { CircularProgress, RaisedButton, TextField } from "material-ui";
import * as validator from "../../../general/validators/validator";
import * as PaperService from "../../../services/paper-service";
import * as ErrorAction from "../../../redux/action/error-action";
import { connect } from "react-redux";

const axios = require("axios");

class PaperAddModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true,
      loadingData: true,
      savingInProgress: false,
      errorLoading: false,
      error: {
        justification: null,
        acquisitionCategory: null,
        financeSource: null,
        articles: null
      },
      acquisitionCategoryOps: [],
      productOps: [],
      financeSourceOps: [],
      articles: []
    };
  }

  componentDidMount() {
    this.props.hideError();
    if (this.props.data) {
      this.setState({
        justification: this.props.data.justification,
        selectedCategory: this.props.data.acquisitionCategory.id,
        selectedFinancialSource: this.props.data.financeSource.id,
        articles: this.props.data.articles,
        yearId: this.props.data.yearId,
        createdYear: this.props.data.createdYear,
        orderId: this.props.data.orderId,
        id: this.props.data.id
      });
    }
    this.getData();
    this.setState({});
  }

  componentWillUnmount() {
    this.props.hideError();
  }

  getData = () => {
    this.setState({ loadingData: true });
    const acquisitionCategories = request({
      url: Constants.SERVER_ENDPOINT + "/acquisition-category/all",
      method: "get"
    });
    const getProducts = request({
      url: Constants.SERVER_ENDPOINT + "/product/all",
      method: "get"
    });
    const getFinanceSource = request({
      url: Constants.SERVER_ENDPOINT + "/finance-source/all",
      method: "get"
    });

    axios
      .all([acquisitionCategories, getProducts, getFinanceSource])
      .then(
        axios.spread((acquisitionCategories, products, financeSources) => {
          this.setState({
            products: products.data,
            acquisitionCategoryOps: acquisitionCategories.data.map((t, i) => {
              return { value: t.id, label: t.name };
            }),
            financeSourceOps: financeSources.data.map((t, i) => {
              return { value: t.id, label: t.name };
            }),
            loadingData: false,
            errorLoading: false
          });
        })
      )
      .catch(error => {
        this.setState({
          loadingData: false,
          errorLoading: true
        });
      });
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false
    });
    this.props.onCancel();
  };

  onJustificationChange = e => {
    this.setState({
      justification: e.target.value
    });
  };

  onFinancialSourceChange = val => {
    this.setState({
      selectedFinancialSource: val
    });
  };

  onCategoryChange = val => {
    this.setState({
      selectedCategory: val
    });
  };

  onAddArticleClicked = articles => {
    this.setState({
      articles: articles
    });
  };

  onDeleteClicked = index => {
    let newArticles = this.state.articles;
    newArticles.splice(index, 1);
    this.setState({
      articles: newArticles
    });
  };

  onSaveAsDraft = () => {
    this.saveToServer(true);
  };

  onSend = () => {
    this.saveToServer(false);
  };

  saveToServer = isDraft => {
    this.props.hideError();
    let body = {
      id: this.state.id,
      justification: this.state.justification,
      acquisitionCategoryId: this.state.selectedCategory,
      financeSourceId: this.state.selectedFinancialSource,
      articles: this.state.articles,
      isDraft: isDraft,
      forNextYear: this.props.forNextYear
    };

    if (!this.validateInput()) {
      return;
    }

    this.setState({
      savingInProgress: true
    });
    PaperService.addPaper(body)
      .then(t => {
        this.setState({
          justification: null,
          selectedCategory: null,
          selectedFinancialSource: null,
          articles: [],
          savingInProgress: false
        });
        this.props.addFinished();
      })
      .catch(err => {
        this.setState({
          savingInProgress: false
        });
        this.props.showError("Salvarea a esuat! Va rog reincercati!");
      });
  };

  validateInput = () => {
    let found = false;
    let error = {};

    if (validator.isEmpty(this.state.justification)) {
      found = true;
      error.justification = "Lipsa justificare";
    }
    if (validator.isEmpty(this.state.selectedCategory)) {
      found = true;
      error.acquisitionCategory = "Nu ati selectat categoria de achizitie";
    }
    if (validator.isEmpty(this.state.selectedFinancialSource)) {
      found = true;
      error.financeSource = "Nu ati selectat sursa de finantare";
    }
    if (!this.state.articles || this.state.articles.length === 0) {
      found = true;
      error.articles = "Nu ati adaugat articole";
    }

    let newArticles = this.state.articles;
    for (let i = 0; i < this.state.articles.length; i++) {
      let error = this.validateArticle(this.state.articles[i]);
      if (error) {
        found = true;
        newArticles[i].error = error;
      } else {
        newArticles[i].error = null;
      }
    }
    this.setState({
      articles: newArticles,
      error: error
    });
    return !found;
  };

  validateArticle = article => {
    let found = false;
    let error = {};
    let price = article.pricePerUnit;
    if (validator.isEmpty(price) || price === 0 || price === "0" || price < 0) {
      found = true;
      error.pricePerUnit = "Lipseste pretul sau este 0";
    }
    let quantity = article.quantity;
    if (
      validator.isEmpty(quantity) ||
      quantity === 0 ||
      quantity === "0" ||
      quantity < 0
    ) {
      found = true;
      error.quantity = "Lipseste cantitatea sau este 0";
    }
    let vat = article.vat;
    if (validator.isEmpty(vat) || vat < 0) {
      found = true;
      error.vat = "Lipseste TVA-ul sau este negativ";
    }
    if (validator.isEmpty(article.product)) {
      found = true;
      error.product = "Lipsa produs";
    }
    if (!found) {
      return null;
    }
    return error;
  };

  onPricePerUnitChanged = (e, index) => {
    let newPrice = e.target.value;
    let article = this.state.articles[index];
    article.pricePerUnit = newPrice;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles
    });
  };

  onDetailChanged = (e, index) => {
    let newDetails = e.target.value;
    let article = this.state.articles[index];
    article.details = newDetails;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles
    });
  };

  onVatChanged = (e, index) => {
    let newQuantity = e.target.value;
    let article = this.state.articles[index];
    article.vat = newQuantity;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles
    });
  };

  onQuantityChanged = (e, index) => {
    let newQuantity = e.target.value;
    let article = this.state.articles[index];
    article.quantity = newQuantity;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles
    });
  };

  onArticolBugetarChange = (e, index) => {
    let newValue = e.target.value;
    let article = this.state.articles[index];
    article.articolBugetar = newValue;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles
    });
  };

  render() {
    let totalPriceNoVat = 0;
    let totalPriceWithVat = 0;
    this.state.articles.forEach(e => {
      let priceAllNoVat = e.quantity * e.pricePerUnit;
      totalPriceWithVat += (priceAllNoVat * e.vat) / 100 + priceAllNoVat;
      totalPriceNoVat += e.quantity * e.pricePerUnit;
    });

    totalPriceNoVat = Math.round(totalPriceNoVat * 100) / 100;
    totalPriceWithVat = Math.round(totalPriceWithVat * 100) / 100;
    return (
      <div>
        <RedirectIfNotLogged />

        <SkyLightStateless
          isVisible={this.state.modalIsOpen}
          dialogStyles={styles.defaultDialogStyles}
          onCloseClicked={this.closeModal}
          title={
            !this.state.errorLoading && <Header title={this.props.title} />
          }
        >
          <div
            id={"parent"}
            style={{ maxHeight: "700px", display: "block", overflow: "auto" }}
          >
            {this.state.errorLoading ? (
              <div style={{ textAlign: "center" }}>
                <h1>A aparut o problema. Va rog reincercati!</h1>
              </div>
            ) : this.state.loadingData ? (
              <div style={{ textAlign: "center" }}>
                <CircularProgress />
              </div>
            ) : (
              <div>
                <table className="table  table-hover">
                  <tbody>
                    <tr>
                      <td>Justificare achizitiei</td>
                      <td>
                        <TextField
                          style={{ textAlign: "left", width: "100%" }}
                          floatingLabelText="Justificarea achizitiei"
                          multiLine={true}
                          rows={2}
                          errorText={this.state.error.justification}
                          value={this.state.justification}
                          onChange={this.onJustificationChange}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>Categorie achizitie</td>
                      <td>
                        <div>
                          <Select
                            ref="stateSelect"
                            autoFocus
                            options={this.state.acquisitionCategoryOps}
                            simpleValue
                            clearable={true}
                            name="selected-state"
                            disabled={false}
                            value={this.state.selectedCategory}
                            onChange={this.onCategoryChange}
                            searchable={true}
                          />
                          <div>
                            {this.state.error.acquisitionCategory && (
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "rgb(244, 67, 54)",
                                  marginTop: "5px"
                                }}
                              >
                                {this.state.error.acquisitionCategory}
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Sursa de finantare</td>
                      <td>
                        <div>
                          <Select
                            ref="stateSelect"
                            autoFocus
                            options={this.state.financeSourceOps}
                            simpleValue
                            clearable={true}
                            name="selected-state"
                            disabled={false}
                            value={this.state.selectedFinancialSource}
                            onChange={this.onFinancialSourceChange}
                            searchable={true}
                          />
                          <div>
                            {this.state.error.financeSource && (
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "rgb(244, 67, 54)",
                                  marginTop: "5px"
                                }}
                              >
                                {this.state.error.financeSource}
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div>
                  <div>
                    <div>
                      {!this.state.loadingData && (
                        <ArticleAddTable
                          vat={this.state.vat}
                          articles={this.state.articles}
                          yearId={this.state.yearId}
                          createdYear={this.state.createdYear}
                          orderId={this.state.orderId}
                          products={this.state.products}
                          onDetailChanged={this.onDetailChanged}
                          onVatChanged={this.onVatChanged}
                          onQuantityChanged={this.onQuantityChanged}
                          onArticolBugetarChange={this.onArticolBugetarChange}
                          onPricePerUnitChanged={this.onPricePerUnitChanged}
                          onAddArticleClicked={this.onAddArticleClicked}
                          onDeleteClicked={this.onDeleteClicked}
                        />
                      )}
                      <div style={{ textAlign: "center" }}>
                        {this.state.error.articles && (
                          <div
                            style={{
                              fontSize: "12px",
                              color: "rgb(244, 67, 54)",
                              marginTop: "5px"
                            }}
                          >
                            {this.state.error.articles}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div style={{ width: "100%", display: "flex" }}>
                    <div style={{ margin: "0 auto" }}>
                      <strong>Pret total fara TVA</strong>
                    </div>

                    <div style={{ margin: "0 auto" }}>
                      <strong>Pret total cu TVA</strong>
                    </div>
                  </div>

                  <div style={{ width: "100%", display: "flex" }}>
                    <div style={{ margin: "0 auto" }}>
                      <span>{totalPriceNoVat}</span>
                    </div>

                    <div style={{ margin: "0 auto" }}>
                      <span>{totalPriceWithVat}</span>
                    </div>
                  </div>

                  <div style={{ paddingTop: "50px" }}>
                    <RaisedButton
                      secondary
                      type={"button"}
                      style={{ float: "right", marginBottom: "20px" }}
                      label={"Renunta"}
                      onClick={() => this.closeModal()}
                    />
                    <RaisedButton
                      primary
                      disabled={this.state.savingInProgress}
                      type={"button"}
                      style={{
                        float: "right",
                        marginBottom: "20px",
                        marginRight: "20px"
                      }}
                      label={"Salveaza si trimite mai departe"}
                      onClick={() => this.onSend()}
                    />
                    <RaisedButton
                      primary
                      disabled={this.state.savingInProgress}
                      type={"button"}
                      style={{
                        float: "right",
                        marginBottom: "20px",
                        marginRight: "20px"
                      }}
                      label={"Salveaza si modifica mai tarziu"}
                      onClick={() => this.onSaveAsDraft()}
                    />
                  </div>
                </div>

                <div style={{ textAlign: "center" }}>
                  {this.state.savingInProgress && <CircularProgress />}
                </div>
              </div>
            )}
          </div>
        </SkyLightStateless>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    showError: text => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaperAddModal);
